import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, ParamMap, Router } from '@angular/router';
import { AppBreadcrumbService } from 'src/app/app.breadcrumb.service';
import { utility } from 'src/app/common/utility';
import { MemberService } from 'src/app/services/MemberService';
import { environment } from 'src/environments/environment';
import { AccountService } from '../../services/AccountService';

@Component({
  selector: 'app-member-view',
  templateUrl: './member-view.component.html',
  styleUrls: ['./member-view.component.scss']
})
export class MemberViewComponent implements OnInit {

  member: any ;
  memberid: any;
  officelocations:any[] = [];
  territories:any[] = [];
  currentTab: any; 
  agentCols: any[] = [];
  contactCols: any[] = [];
  officeCols: any[] = [];
  latitude: number;
  longitude: number;
  zoom:number;
  kmlurl: string;
  canEditMember: boolean = false;  
  canEditMemberTerritory: boolean = false;
  
  constructor(private activatedRoute: ActivatedRoute,
      private breadcrumbService: AppBreadcrumbService,
      private router: Router,
      private accountService: AccountService) { }

  ngOnInit(): void {
      this.initializeMember();     
      this.activatedRoute.paramMap.subscribe((params: ParamMap) => {
        this.setCurrentLocation();
        this.memberid = parseInt(params.get('id'));           
        this.kmlurl =   environment.kmlBase.concat('/TerritoryKML/', this.memberid,'.kml?t=', Date.now().toString());              
        this.member = this.activatedRoute.snapshot.data['member'];   
        this.officelocations = this.activatedRoute.snapshot.data['officelocations'] 
        this.territories =this.activatedRoute.snapshot.data['territories'];
        this.member.Logo = 'data:image/png;base64,' + this.member.Logo;
        this.member.Icon = 'data:image/png;base64,' + this.member.Icon;
        this.canEditMember = this.accountService.CanEditMember(this.memberid);
        this.canEditMemberTerritory = this.accountService.CanEditMemberTerritory();
        this.breadcrumbService.setItems([         
          { label: 'Member: ' + this.member.Name, routerLink: [] }          
      ]);        
    });
    this.officeCols = [
      { field: 'Id', header: 'Id', display: 'none' },
      { field: 'Name', header: 'Name', display: 'none' },
      { field: 'Address', header: 'Address', display: 'table-cell' },
      { field: 'City', header: 'City' , display: 'table-cell' },
      { field: 'StatesName', header: 'State' , display: 'table-cell'},
      { field: 'CountriesName', header: 'Country' , display: 'table-cell'}      
    ];
    this.agentCols = [
      { field: 'Id', header: 'Id', display: 'none' },
      { field: 'Name', header: 'Name', display: 'none' },
      { field: 'Title', header: 'Title' },
      { field: 'Specialties', header: 'Specialties' },
      { field: 'DirectPhone', header: 'Direct Phone' },
      { field: 'Email', header: 'Email' },        
      {field: 'IsApprovingManager', header: 'Approving Manager'}
    ];
    this.contactCols = [
      { field: 'Id', header: 'Id', display: 'none' },
      { field: 'Name', header: 'Name' },
      { field: 'Title', header: 'Title' },
      { field: 'Role', header: 'Role' },
      { field: 'DirectPhone', header: 'Direct Phone' },
      { field: 'Email', header: 'Country' },              
      {field: 'IsApprovingManager', header: 'Approving Manager'}
    ];

    
  }

  initializeMember()
  {
     this.member = {};       
     this.officelocations = []; 
     this.territories = [];    
  }
  onTabOpen(e) {
    this.currentTab = e.index;    
    if(this.currentTab == 4)
    {
      this.zoom = 5; 
    }
  }
  FormatColumnData(value: any, col: any): string {
    var result = value;
   
    return result;
  }
  
  IsPaginatorOffLocationVisible():boolean
  {
    return this.officelocations ? (this.officelocations.length > 20 ? true: false): false;
  }
  IsOfficeLocationDataTableVisible():boolean
  {
    return this.officelocations ? (this.officelocations.length > 0 ? true: false): false;
  }
  IsPaginatorAgentStaffVisible():boolean
  {
    if(this.member!= null && this.member.AgentsAndStaff != null)
    {
      return this.member.AgentsAndStaff.length > 20 ? true: false;
    }
    return false; 
  }
  IsAgentStaffDataTableVisible():boolean
  {
    if(this.member!= null && this.member.AgentsAndStaff != null)
    {
      return this.member.AgentsAndStaff.length > 0 ? true: false;
    }
    return false; 
  }
  FormatAgentColumnData(value: any, col: any): string {
    var result = value;   
    return result;
  }
  formatUrl(url:any)
  {
    return utility.formatUrl(url);
  }
 
  formatUrlforDisplay(url:any)
  {
    return utility.formatURLForDisplay(url);   
  }
  downloadVCard(vcard:string)
  {
    let vCardUrl = 'data:text/vcard;charset=utf-8,' + encodeURIComponent(vcard);
  }
  NavMailto(email:string) {
    window.location.href = "mailto:" + email;
  }
  getUserImageSrc(user:any)
  {
     return  user.ProfilePicture ? 'data:image/png;base64,' + user.ProfilePicture: 'assets/layout/images/naiimages/userimages.png';
  }
  // Get Current Location Coordinates
   private setCurrentLocation() {
     if ('geolocation' in navigator) {
       navigator.geolocation.getCurrentPosition((position) => {
         this.latitude = position.coords.latitude;
         this.longitude = position.coords.longitude;
         this.zoom = 8;
       });
     }
  }
  navToMemberProfile(Id) {
    this.router.navigate(['/member/' + Id]);
  }
  navToUserProfile(Id) {
    this.router.navigate(['/user/' + Id]);
  }

  getUserFullName(rowdata)
  {
    if(rowdata!= null)
    {
      return rowdata.FName + " " + rowdata.LName
    }
  }
}
